'use client';

import { usePathname } from 'next/navigation';

import { useIsWebview } from '@flipster/features/src/shared/webview';

import { AlertBanner } from './alert-banner';
import Gnb from './gnb';
import type { GnbPromotionItemFragment } from './query.generated';
import { UserLanguageRedirect } from './user-language-redirect';

export const Navigation = ({ promotion }: { promotion?: GnbPromotionItemFragment }) => {
  const pathname = usePathname();
  const isWebview = useIsWebview();

  const isHidePath = ['/maintenance', '/fullchart', '/campaign/token-2049-2025'].some((path) =>
    pathname.includes(path),
  );

  if (isWebview || isHidePath) return null;
  return (
    <>
      <Gnb promotion={promotion} />
      <AlertBanner />
      <UserLanguageRedirect />
    </>
  );
};
